module.exports = __webpack_public_path__ + "img/23.240b4a21.jpg";